import styled from 'styled-components'
import Button from 'components/Button/Button'

export const RosterButton = styled(Button)`
  margin: 5px;
  color: '#002855';
`
export const RosterColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
`
export const RosterLayoutSection = styled.div`
  display: flex;
`
export const RosterLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
export const Instructions = styled.span`
  display: flex;
  font-family: Molde-bold;
  padding: 0.6rem 0;
`
export const ExampleImage = styled.img`
  display: flex;
  width: 100%;
`
export const UploadSection = styled.div`
  display: flex;
  padding: 1rem 0 0.5rem;

  & > div {
    display: flex;
    flex: 1;
  }

  & > div + div {
    justify-content: flex-end;
    align-items: baseline;
  }
`
export const ResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => (props.hasErrors ? 'red' : 'green')};
`
export const List = styled.ul`
  padding-left: 1rem;
`
export const AccessTokenList = styled.ul`
  padding-left: 1rem;
  list-style-type: none;
`

export const AccessToken = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const AccessTokenText = styled.span`
  padding: 0rem 0.25rem;
`

export const AccessCodeResultWrapper = styled.div`
  color: black;
  padding-top: 1rem;
`

export const AccessCodeResultInnerWrapper = styled.div`
  max-height: 15rem;
  overflow-y: auto;
  padding-right: 1rem;
`



// WEBPACK FOOTER //
// ./src/containers/css-admin/roster/styles.js